import {jQuery as $} from 'lib/shim';

import {IS_IOS_SAFARI} from 'defines';

import {Context} from 'context';


const SELECTOR = '.organism-message-overlay';


class OrganismMessageOverlay {

	constructor(app, $element) {
		if (!$.isSet($element.dataDuo('primed'))) {
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$acknowledgeButton = this._$element.find('.acknowledge-button');
			this._overlayId = this._$element.data('overlay-id');
			this._$overlayTrigger = $('body').find('.overlay-trigger[data-overlay-id="' + this._overlayId + '"], .cta-link[data-overlay-id="' + this._overlayId + '"]');


			this._prime();
			this._initPatternLabDemoBehaviour();
		}
	}


	_prime() {
		this._$element.on('click', (e) => {
			e.preventDefault();

			if (!$(event.target).closest('.background').length) {
				this._$element.removeClass('open');
			}
		});

		this._$acknowledgeButton.on('click', (e) => {
			e.preventDefault();

			this._$element.removeClass('open');
			if (this._$overlayTrigger.attr('href')){
				window.location.href = this._$overlayTrigger.attr('href');
			}
		});

		if (this._$overlayTrigger && this._$overlayTrigger.length && this._$overlayTrigger.data('overlay-id')) {
			this._$overlayTrigger.on('click', (e) => {
				e.preventDefault();
				this._$element.addClass('open');
			});
		}
	}


	_initPatternLabDemoBehaviour() {
		if (
			(
				Context.get('runningInPatternLabDetails')
				|| Context.get('runningInPatternLabList')
			) && (this._$element.parent().closest('[class^="organism-"]').length === 0)
		) {
			let $trigger = $('<button class="atom-primary-button pl-test-button">open overlay</button>');

			$trigger.on('click', (e) => {
				e.preventDefault();

				this._$element.addClass('open');
			});

			this._$element.after($trigger);
		}

		if (Context.get('runningInPatternLabList') && IS_IOS_SAFARI) {
			let $unavailableMessage = $('<p class="pl-message">'
				+ 'On iOS, the lightbox may be too high due to a pattern-lab-specific iFrame problem, '
				+ 'have a look at the pattern in the pattern detail view or try double tapping the lightbox '
				+ 'title to apply filters even if the apply button may be unreachable.'
				+ '</p>');

			this._$element.after($unavailableMessage);
		}
	}
}


export function init(app) {
	let $elements = $();

	$(SELECTOR).each(function () {
		let $this = $(this);
		new OrganismMessageOverlay(app, $this);
		$elements = $elements.add($this);
	});

	return $elements;
}
